import { Navigate, useLocation } from 'react-router-dom'
import { useIsAuthenticated, useIsAuthLoading } from '@/store'

interface ProtectedRouteProps {
  children: React.ReactNode
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const isAuthenticated = useIsAuthenticated()
  const isAuthLoading = useIsAuthLoading()
  const location = useLocation()

  if (isAuthLoading) {
    return (
      <div className="min-h-screen bg-cosmic-void flex items-center justify-center">
        <CosmicLoader />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  return <>{children}</>
}

function CosmicLoader() {
  return (
    <div className="flex flex-col items-center gap-6">
      {/* Rotating mandala ring */}
      <div className="relative w-16 h-16">
        <div className="absolute inset-0 rounded-full border-2 border-cosmic-mist animate-spin-slow" />
        <div
          className="absolute inset-1 rounded-full border border-gold/30 animate-spin-slow"
          style={{ animationDirection: 'reverse', animationDuration: '8s' }}
        />
        <div className="absolute inset-[6px] rounded-full bg-cosmic-nebula flex items-center justify-center">
          <span className="text-gold text-lg">✦</span>
        </div>
      </div>
      <p className="text-star-muted text-sm font-mono tracking-widest uppercase animate-pulse">
        Aligning stars…
      </p>
    </div>
  )
}
